import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { MobileBar } from "./components/MobileBar";
import { CookieConsent } from "./components/CookieConsent";
import { IntroOverlay } from "./components/IntroOverlay";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Events from "./pages/Events";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Locations from "./pages/Locations";
import Contact from "./pages/Contact";
import { Privacy, Terms, Disclaimer } from "./pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
};

const Shell = () => {
  useLenis();
  return (
    <>
      <ScrollToTop />
      <IntroOverlay />
      <Header />
      <main className="pb-16 md:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/events" element={<Events />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/about" element={<About />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-of-use" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <MobileBar />
      <CookieConsent />
    </>
  );
};

function App() {
  return (
    <div className="grain min-h-screen bg-obsidian">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: { background: "#0C1520", border: "1px solid rgba(199,164,91,0.3)", color: "#F4F0E8" },
        }}
      />
    </div>
  );
}

export default App;
